import { render } from "./SocialLogin.vue?vue&type=template&id=55ec6d1c&scoped=true"
import script from "./SocialLogin.vue?vue&type=script&lang=ts"
export * from "./SocialLogin.vue?vue&type=script&lang=ts"

import "./SocialLogin.vue?vue&type=style&index=0&id=55ec6d1c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-55ec6d1c"

export default script